/* eslint-disable */
import axios from 'axios';
import join from 'url-join';
import { server, apiUrl, NOT_CONNECT_NETWORK, NETWORK_CONNECTION_MESSAGE, NO } from '../constants';

const isAbsoluteURLRegex = /^(?:\w+:)\/\//;

axios.interceptors.request.use(async (config) => {
  if (!isAbsoluteURLRegex.test(config.url)) {
    config.url = join(apiUrl, config.url);
  }

  // เพิ่ม JWT token ใน header (ถ้ามี)
  const token = localStorage.getItem('jconnect_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  config.timeout = 10000; // 10 Second
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // debugger;
    // console.log(JSON.stringify(error, undefined, 2));

    // ตรวจสอบ error response สำหรับ token ไม่ถูกต้องหรือหมดอายุ
    if (error.response && error.response.status === 401) {
      // ลบ token และข้อมูล session
      localStorage.removeItem('jconnect_token');
      localStorage.setItem(server.LOGIN_PASSED, NO);
      localStorage.removeItem(server.LOGIN_USERNAME);
      localStorage.removeItem(server.LOGIN_MENU);
      localStorage.removeItem(server.LOGIN_PLANT);
      localStorage.removeItem(server.LOGIN_PANTRY);

      // Redirect ไปหน้า login
      window.location.href = '/login';
      // return Promise.reject(); // Reject without error to prevent additional error handling
    }

    // if (axios.isCancel(error)) {
    //   return Promise.reject(error);
    // } else if (!error.response) {
    //   return Promise.reject({ code: NOT_CONNECT_NETWORK, message: NETWORK_CONNECTION_MESSAGE });
    // }

    if (error.response) {
      // The server responded with a status code outside the 2xx range
      console.log('Error response:', error.response);
    } else if (error.request) {
      // The request was made but no response was received
      console.log('Error request:', error.request);
    } else {
      // Something happened in setting up the request that triggered an error
      console.log('Error message:', error.message);
    }
  }
);

export const httpClient = axios;
